import React from "react";
import { CloseCircle } from "iconsax-react";

interface Category {
  id: string;
  name: string;
}

interface SearchFilterNameProps {
  checkedNames: Category[];
  setCheckedNames: React.Dispatch<React.SetStateAction<Category[]>>;
  checkedItems: Record<string, boolean>;
  setCheckedItems: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  brandNames?: string[];
  setCheckedBrandNames?: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  setCheckedBrandItems?: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

function SearchFilterName({
  checkedNames,
  setCheckedNames,
  setCheckedItems,
  setCheckedBrandNames,
  setCheckedBrandItems,
  checkedBrandNames,
}: SearchFilterNameProps) {
  // حذف یک دسته‌بندی (آنچک خارج)
  const handleRemoveCategory = (cat: Category) => {
    setCheckedItems((prev) => ({
      ...prev,
      [cat.id]: false,
    }));
    setCheckedNames((prev) => prev.filter((item) => item.id !== cat.id));
  };
  const handleRemoveBrand = (brand: Category) => {
    if (setCheckedBrandItems || setCheckedBrandNames) {
      setCheckedBrandItems((prev) => ({
        ...prev,
        [brand.id]: false,
      }));
      setCheckedBrandNames((prev) =>
        prev.filter((item) => item?.id !== brand?.id)
      );
    }
  };

  return (
    <div className="mt-5 lg:flex hidden gap-4 flex-wrap">
      {checkedNames?.map((cat) => (
        <div
          key={cat.id}
          className="bg-white p-2 px-3 rounded-full text-sm flex items-center gap-3"
        >
          {cat.name}
          <CloseCircle
            onClick={() => handleRemoveCategory(cat)}
            size={20}
            className="cursor-pointer"
            color="#686868"
          />
        </div>
      ))}
      {checkedBrandNames?.map((brand) => (
        <div
          key={brand?.id}
          className="bg-white p-2 px-3 rounded-full text-sm flex items-center gap-3"
        >
          {brand?.name}
          <CloseCircle
            onClick={() => handleRemoveBrand(brand)}
            size={20}
            className="cursor-pointer"
            color="#686868"
          />
        </div>
      ))}
    </div>
  );
}

export default SearchFilterName;
